// Main SASS file (all other SASS imports are managed in .scss files)
require('./stylesheets/main.scss');

// Utilities JS
require('./js/utilities');

// Page-Specific JS
require('./js/course-listing');
require('./js/registration');


/** WEBPACK FOOTER **
 ** ./main.js
 **/